enum CoolingStatus {
  INTERNAL_DATABASE_UPDATE = 'INTERNAL_DATABASE_UPDATE',
  INSTALLATION_FAILED = 'INSTALLATION_FAILED',
  ORDER_CANCELED = 'ORDER_CANCELED',
  SAV = 'SAV',
  NO_STATUS = 'NO_STATUS'
}

export default CoolingStatus;
